import { EventEmitter, Input, Output } from '@angular/core';
import * as moment from 'moment';

/**
 * This class is used to define base structure
 * for calendar view modes components
 */
export abstract class DatePickerInlineBaseComponent {
  /**
   * The flag indicating that we should have the range dates
   */
  @Input() isRange: boolean;

  /**
   * The current date
   */
  @Input() current: moment.Moment;

  /**
   * The start date
   */
  @Input() start: moment.Moment;

  /**
   * The end date
   */
  @Input() end: moment.Moment;

  /**
   * The min date
   */
  @Input() min: moment.Moment;

  /**
   * The max date
   */
  @Input() max: moment.Moment;

  /**
   * The flag indicating that calendar disabled
   */
  @Input() disabled: boolean;

  /**
   * The current date change event
   */
  @Output() currentChange: EventEmitter<moment.Moment> = new EventEmitter<moment.Moment>();

  /**
   * The start date change event
   */
  @Output() startChange: EventEmitter<moment.Moment> = new EventEmitter<moment.Moment>();

  /**
   * The end date change event
   */
  @Output() endChange: EventEmitter<moment.Moment> = new EventEmitter<moment.Moment>();

  /**
   * The dates change event
   */
  @Output() datesChange: EventEmitter<void> = new EventEmitter<void>();
}
